import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';
import { FormGroupContext } from '../../Molecules/FormGroup';
import { useId } from '../../Utils/Hooks';
import { KEYCODE_ENTER, KEYCODE_SPACEBAR } from '../../Constants';

const { StyledRadio, StyledCheck, StyledInput, StyledLabel } = Styles;

export const Radio = ({
    name,
    className,
    defaultChecked,
    defaultValue,
    onChange,
    disabled,
    label,
    highlighted,
    ...otherProps
}) => {
    const inputRef = React.useRef(null);
    const [id] = useId('radio');

    const handleOnClick = () => {
        inputRef.current.click();
    };

    const handleOnKeyPress = evt => {
        const actionKeys = [KEYCODE_ENTER, KEYCODE_SPACEBAR];
        const key = evt.keyCode || evt.charCode;
        if (actionKeys.includes(key)) {
            evt.preventDefault();
            evt.stopPropagation();
            handleOnClick();
        }
    };

    return (
        <>
            <FormGroupContext.Consumer>
                {({ name: formGroupName, onChange: formGroupOnchange = () => null } = {}) => (
                    <StyledInput
                        name={name || formGroupName}
                        ref={inputRef}
                        defaultChecked={defaultChecked}
                        defaultValue={defaultValue}
                        disabled={disabled}
                        onChange={evt => {
                            onChange(evt);
                            formGroupOnchange(evt);
                        }}
                        {...otherProps}
                    />
                )}
            </FormGroupContext.Consumer>
            <StyledRadio
                id={id}
                className={className}
                onClick={handleOnClick}
                tabIndex={0}
                onKeyPress={handleOnKeyPress}
                disabled={disabled}
                highlighted={highlighted}
            >
                <StyledCheck />
                {label ? <StyledLabel>{label}</StyledLabel> : null}
            </StyledRadio>
        </>
    );
};

Radio.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    defaultChecked: PropTypes.bool,
    highlighted: PropTypes.bool,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    label: PropTypes.node,
    onChange: PropTypes.func,
};

/* istanbul ignore next */
Radio.defaultProps = {
    className: '',
    name: '',
    defaultChecked: false,
    highlighted: false,
    defaultValue: '',
    disabled: false,
    label: undefined,
    onChange: () => undefined,
};

Radio.Styles = Styles;
